import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { DataPointItem } from '@/store/profile.interface'
import { ElEmpty, ElInputNumber, ElMessageBox, ElTableColumn } from 'element-plus'
import { reactive, ref } from 'vue'
import { NewProfileStore } from '@/store/newProfileStore'
import { Plus, Delete } from '@element-plus/icons-vue'
import { IsBACnetObjectWritable } from '@/store/bactype'
interface ValidStateMap {
  FALSE: 0
  TRUE: 1
  UNCONFIRMED: 2
}

interface DataPointTestResultItem {
  dataPoint: DataPointItem,
  value: number | string | undefined,
  isValid: ValidStateMap[keyof ValidStateMap]
}

interface UplinkTestInputItem {
  fport: number,
  rawData: string
}
interface UplinkInputForm {
  uplinkInput: UplinkTestInputItem[]
}

interface DownlinkTestInputItem {
  channel: number,
  value: number | undefined
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CodecValidator',
  setup(__props, { expose: __expose }) {

const inputTestConsole = ref('')
const profileStore = new NewProfileStore()

const ValidateState: ValidStateMap = {
  FALSE: 0,
  TRUE: 1,
  UNCONFIRMED: 2
}
const formatHex = (input: UplinkTestInputItem) => {
  const cleanInput = input.rawData.replace(/[^0-9a-fA-F]/g, '')
  const formatted = cleanInput.match(/.{1,2}/g)?.join(' ') || ''
  input.rawData = formatted.toUpperCase()
}

const UplinkStatusTable = ref<DataPointTestResultItem[]>(profileStore.DataPoints().map(dp => ({ dataPoint: dp, value: undefined, isValid: ValidateState.UNCONFIRMED })))

const UplinkTestInput = reactive<UplinkInputForm>({ uplinkInput: [{ fport: 1, rawData: '' }] })

const OnAddNewUplinkItem = () => {
  UplinkTestInput.uplinkInput.push({ fport: 1, rawData: '' })
}

function hexStringToArray(hexString: string): number[] {
  const result: number[] = []

  for (let i = 0; i < hexString.length; i += 2) {
    const byte = parseInt(hexString.substr(i, 2), 16)
    result.push(byte)
  }

  return result
}

const showTestResult = ref<boolean>(false)

const UplinkResultTable = ref<DataPointTestResultItem[]>([])
const OnUplinkTest = async () => {
  inputTestConsole.value = ''
  UplinkResultTable.value = []
  const AppendUplinkResultToTable = (result:any) => {
    const datapoints = profileStore.DataPoints()
    if (Array.isArray(result.data)) {
      for (let i = 0; i < result.data.length; i++) {
        const item = result.data[i]
        console.log(item)
        if (item.channel) {
          datapoints.forEach(dp => {
            console.log(dp)
            if (dp.channel === item.channel) {
              UplinkResultTable.value.push({
                dataPoint: dp,
                value: item.value,
                isValid: 2
              })
            }
          })
        }
      }
    }
  }

  const ExecInputTestItem = (fport: number, data: string, script: any) => {
    try {
      console.log(`#### ${data} ###`)
      const result = script.decodeUplink({
        fPort: fport,
        bytes: hexStringToArray(data),
        variables: {}
      })

      console.log(`### ${JSON.stringify(result)} ###`)
      showTestResult.value = true
      AppendUplinkResultToTable(result)

      inputTestConsole.value += JSON.stringify(result, null, 4)
    } catch (error:any) {
      console.log(error.message)
    }
  }
  const codec = profileStore.GetCodec()
  // eslint-disable-next-line no-new-func
  const func = new Function(codec + 'return {decodeUplink, encodeDownlink};')
  // eslint-disable-next-line @typescript-eslint/ban-types
  const script:{ decodeUplink: Function, encodeDownlink: Function} = func()

  UplinkTestInput.uplinkInput.forEach(item => {
    console.log(`try to test fport ${item.fport} ${item.rawData}`)
    ExecInputTestItem(parseInt(item.fport), item.rawData.replace(/\s/g, ''), script)
  })
}

const CloseUplinkResultDialog = () => {
  UplinkResultTable.value.forEach(resultItem => {
    UplinkStatusTable.value.forEach(stateItem => {
      if (resultItem.dataPoint.channel === stateItem.dataPoint.channel) {
        stateItem.isValid = resultItem.isValid
      }
    })
  })
  showTestResult.value = false
}

const DownlinkStatusTable = ref<DataPointTestResultItem[]>(profileStore.DataPoints().filter(item => { return IsBACnetObjectWritable(item.type) }).map(item => ({
  dataPoint: item,
  isValid: ValidateState.UNCONFIRMED,
  value: undefined
})))

const showDownlinkTestResult = ref(false)
const downlinkTestConsole = ref('')

const DownlinkTestInputForm = reactive<DownlinkTestInputItem[]>(profileStore.DataPoints().filter(item => { return IsBACnetObjectWritable(item.type) }).map(item => ({ channel: item.channel!, value: undefined })))
const Submit = async () => {
  return new Promise<void>((resolve, reject) => {
    let invaliditems = 0
    for (let i = 0; i < UplinkStatusTable.value.length; i++) {
      if (UplinkStatusTable.value[i].isValid !== ValidateState.TRUE) {
        invaliditems += 1
      }
    }

    for (let i = 0; i < DownlinkStatusTable.value.length; i++) {
      if (DownlinkStatusTable.value[i].isValid !== ValidateState.TRUE) {
        invaliditems += 1
      }
    }

    if (invaliditems > 0) {
      ElMessageBox.confirm('Here are still some items with failing tests. Do you want to proceed with the submission before completing the tests?', 'Warning', {
        type: 'warning'
      }).then(yes => {
        resolve()
      }).catch(no => {
        reject(new Error('Cancelled due to the unpassed item'))
      })
    } else {
      resolve()
    }
  })
}

const OnDownlinkTest = () => {
  const ExecDownlinkTestItem = (channel: number, value: number, others: DownlinkTestInputItem[], script: any) => {
    console.log(channel, value, others)
    try {
      const result = script.encodeDownlink({
        data: {
          channel: channel,
          value: value
        },
        variables: others
      })

      console.log(result)
      DownlinkStatusTable.value.forEach(item => {
        if (item.dataPoint.channel === channel) {
          item.value = result.bytes.map(byte => (byte.toString(16).padStart(2, '0'))).join(' ')
        }
      })
      showDownlinkTestResult.value = true
      downlinkTestConsole.value += `>> Test Output for channel ${channel}\n`
      downlinkTestConsole.value += JSON.stringify(result)
      downlinkTestConsole.value += '\n\n'
    } catch (error:any) {
      console.log(error.message)
    }
  }

  const codec = profileStore.GetCodec()
  // eslint-disable-next-line no-new-func
  const func = new Function(codec + 'return {decodeUplink, encodeDownlink};')
  // eslint-disable-next-line @typescript-eslint/ban-types
  const script:{ decodeUplink: Function, encodeDownlink: Function} = func()

  DownlinkTestInputForm.forEach(element => {
    if (element.value !== undefined) { ExecDownlinkTestItem(element.channel, element.value!, DownlinkTestInputForm, script) }
  })
}
__expose({ Submit })


return (_ctx: any,_cache: any) => {
  const _component_ElText = _resolveComponent("ElText")!
  const _component_ElRow = _resolveComponent("ElRow")!
  const _component_ElCol = _resolveComponent("ElCol")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElIcon = _resolveComponent("ElIcon")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_ElTable = _resolveComponent("ElTable")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ElRow, null, {
      default: _withCtx(() => [
        _createVNode(_component_ElText, { class: "section-title" }, {
          default: _withCtx(() => [
            _createTextVNode("Uplink Encoder Validator")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ElRow, null, {
      default: _withCtx(() => [
        _createVNode(_component_ElCol, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_ElRow, { style: {"margin-bottom":"12px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ElCol, { span: 2 }),
                _createVNode(_component_ElCol, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElText, null, {
                      default: _withCtx(() => [
                        _createTextVNode("fPort")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ElCol, {
                  span: 11,
                  offset: 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElText, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Uplink RAW Data")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ElCol, { span: 2 })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(UplinkTestInput.uplinkInput, (input, idx) => {
              return (_openBlock(), _createBlock(_component_ElRow, {
                key: idx,
                style: {"margin-bottom":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElCol, { span: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElText, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(idx + 1), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ElCol, { span: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElInput, {
                        modelValue: input.fport,
                        "onUpdate:modelValue": ($event: any) => ((input.fport) = $event),
                        "controls-position": "right"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ElCol, {
                    span: 11,
                    offset: 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElInput, {
                        modelValue: input.rawData,
                        "onUpdate:modelValue": ($event: any) => ((input.rawData) = $event),
                        onInput: ($event: any) => (formatHex(input))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ElCol, {
                    span: 2,
                    style: {"display":"flex","justify-content":"center","align-items":"center"}
                  }, {
                    default: _withCtx(() => [
                      (!(idx == 0 && UplinkTestInput.uplinkInput.length == 1))
                        ? (_openBlock(), _createBlock(_component_ElIcon, {
                            key: 0,
                            onClick: ($event: any) => (UplinkTestInput.uplinkInput.splice(UplinkTestInput.uplinkInput.indexOf(input), 1))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Delete))
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_ElRow, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_ElButton, {
                  type: "default",
                  icon: _unref(Plus),
                  onClick: OnAddNewUplinkItem
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add new Data")
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_ElButton, {
                  type: "primary",
                  onClick: OnUplinkTest
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Test")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ElCol, { span: 14 }, {
          default: _withCtx(() => [
            _createVNode(_component_ElRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_ElTable, {
                  data: UplinkStatusTable.value,
                  stripe: "",
                  "table-layout": "auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElTableColumn), {
                      label: "Channel",
                      prop: "dataPoint.channel"
                    }),
                    _createVNode(_unref(ElTableColumn), {
                      label: "Name",
                      prop: "dataPoint.name"
                    }),
                    _createVNode(_unref(ElTableColumn), {
                      label: "Object Type",
                      prop: "dataPoint.type"
                    }),
                    _createVNode(_unref(ElTableColumn), {
                      label: "Value",
                      prop: "value"
                    }),
                    _createVNode(_unref(ElTableColumn), { label: "Status" }, {
                      default: _withCtx((scope) => [
                        (scope.row.isValid == ValidateState.UNCONFIRMED)
                          ? (_openBlock(), _createBlock(_component_ElTag, {
                              key: 0,
                              type: "info",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Untested")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (scope.row.isValid == ValidateState.TRUE)
                          ? (_openBlock(), _createBlock(_component_ElTag, {
                              key: 1,
                              type: "success",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Pass")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (scope.row.isValid == ValidateState.FALSE)
                          ? (_openBlock(), _createBlock(_component_ElTag, {
                              key: 2,
                              type: "error",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Failed")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ElDialog, {
      modelValue: showTestResult.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showTestResult).value = $event)),
      class: "test-result-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElText, null, {
              default: _withCtx(() => [
                _createTextVNode("Debug Output")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ElRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElInput, {
              type: "textarea",
              style: {"width":"100%"},
              rows: 6,
              modelValue: inputTestConsole.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputTestConsole).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_ElRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElTable, {
              data: UplinkResultTable.value,
              stripe: "",
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElTableColumn), {
                  label: "Channel",
                  prop: "dataPoint.channel"
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Name",
                  prop: "dataPoint.name"
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Object Type",
                  prop: "dataPoint.type"
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Output Value",
                  prop: "value"
                }),
                _createVNode(_unref(ElTableColumn), { label: "Is Correct" }, {
                  default: _withCtx((scope) => [
                    (scope.row.isValid == ValidateState.UNCONFIRMED)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 0,
                          type: "warning",
                          size: "small",
                          onClick: ($event: any) => (scope.row.isValid = ValidateState.TRUE)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Yes")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.isValid == ValidateState.UNCONFIRMED)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 1,
                          type: "warning",
                          size: "small",
                          onClick: ($event: any) => (scope.row.isValid = ValidateState.FALSE)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("No")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.isValid == ValidateState.TRUE)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 2,
                          type: "success",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Pass")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (scope.row.isValid == ValidateState.FALSE)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 3,
                          type: "error",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Failed")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_ElRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElButton, {
              onClick: CloseUplinkResultDialog,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Done")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ElRow, null, {
      default: _withCtx(() => [
        _createVNode(_component_ElText, { class: "section-title" }, {
          default: _withCtx(() => [
            _createTextVNode("Downlink Decoder Validator")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (DownlinkTestInputForm.length === 0)
      ? (_openBlock(), _createBlock(_component_ElRow, {
          key: 0,
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElEmpty))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_ElRow, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_ElCol, { span: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_ElRow, { style: {"margin-bottom":"12px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElCol, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElText)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ElCol, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElText, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Channel")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ElCol, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElText, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Set Value")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(DownlinkTestInputForm, (downlink) => {
                  return (_openBlock(), _createBlock(_component_ElRow, {
                    key: downlink.channel,
                    style: {"margin-bottom":"12px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElCol, { span: 4 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElText)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ElCol, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElInputNumber), {
                            modelValue: downlink.channel,
                            "onUpdate:modelValue": ($event: any) => ((downlink.channel) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ElCol, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElInputNumber), {
                            modelValue: downlink.value,
                            "onUpdate:modelValue": ($event: any) => ((downlink.value) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_ElRow, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElCol, {
                      span: 20,
                      offset: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElButton, {
                          onClick: OnDownlinkTest,
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Test")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ElCol, { span: 14 }, {
              default: _withCtx(() => [
                _createVNode(_component_ElTable, {
                  data: DownlinkStatusTable.value,
                  stripe: "",
                  "table-layout": "auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElTableColumn), {
                      label: "Channel",
                      prop: "dataPoint.channel"
                    }),
                    _createVNode(_unref(ElTableColumn), {
                      label: "Name",
                      prop: "dataPoint.name"
                    }),
                    _createVNode(_unref(ElTableColumn), {
                      label: "Object Type",
                      prop: "dataPoint.type"
                    }),
                    _createVNode(_unref(ElTableColumn), {
                      label: "Downlink RAW Data",
                      prop: "value"
                    }),
                    _createVNode(_unref(ElTableColumn), { label: "Is Correct" }, {
                      default: _withCtx((scope) => [
                        (scope.row.isValid == ValidateState.UNCONFIRMED)
                          ? (_openBlock(), _createBlock(_component_ElTag, {
                              key: 0,
                              type: "info",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Untested")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (scope.row.isValid == ValidateState.TRUE)
                          ? (_openBlock(), _createBlock(_component_ElTag, {
                              key: 1,
                              type: "success",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Pass")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (scope.row.isValid == ValidateState.FALSE)
                          ? (_openBlock(), _createBlock(_component_ElTag, {
                              key: 2,
                              type: "error",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Failed")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_ElDialog, {
      modelValue: showDownlinkTestResult.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDownlinkTestResult).value = $event)),
      class: "test-result-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElText, null, {
              default: _withCtx(() => [
                _createTextVNode("Debug Output")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ElRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElInput, {
              type: "textarea",
              style: {"width":"100%"},
              rows: 6,
              modelValue: downlinkTestConsole.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((downlinkTestConsole).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_ElRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElTable, {
              data: DownlinkStatusTable.value,
              stripe: "",
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElTableColumn), {
                  label: "Channel",
                  prop: "dataPoint.channel"
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Name",
                  prop: "dataPoint.name"
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Object Type",
                  prop: "dataPoint.type"
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Downlink RAW Data",
                  prop: "value"
                }),
                _createVNode(_unref(ElTableColumn), { label: "Is Correct" }, {
                  default: _withCtx((scope) => [
                    (scope.row.isValid == ValidateState.UNCONFIRMED)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 0,
                          type: "warning",
                          size: "small",
                          onClick: ($event: any) => (scope.row.isValid = ValidateState.TRUE)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Yes")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.isValid == ValidateState.UNCONFIRMED)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 1,
                          type: "warning",
                          size: "small",
                          onClick: ($event: any) => (scope.row.isValid = ValidateState.FALSE)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("No")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.isValid == ValidateState.TRUE)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 2,
                          type: "success",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Pass")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (scope.row.isValid == ValidateState.FALSE)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 3,
                          type: "error",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Failed")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_ElRow, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElButton, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showDownlinkTestResult.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Done")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})